// @flow
import map from 'ramda/es/map';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import filter from 'ramda/es/filter';
import identity from 'ramda/es/identity';
import sort from 'ramda/es/sort';
import ascend from 'ramda/es/ascend';
import toPairs from 'ramda/es/toPairs';

import type { Params, SummaryMarks } from 'app/dataTypes/SummaryMarks.types';
import type { Discipline } from 'app/dataTypes/Discipline.types';

import type { Request } from '../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id: number,
  student_id: number,
  date: string,
}

type ResultApi = {
  [discipline_id: string]: {
    title: string,
    marks: {
      year: string,
      [key: string]: string,
    }
  },
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [{
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }, null];
};

export const convertResult = (res: ResultApi): [Array<Discipline>, SummaryMarks] => {
  const disciplines = pipe(
    toPairs,
    map(([id, { title }]) => ({
      id: String(id),
      title: title || '???',
    })),
    sort(ascend(prop('title'))),
  )(res);

  const marks = map(pipe(
    prop('marks'),
    filter(identity),
  ), res);

  return [disciplines, marks];
};

export const GET_SUMMARY: Request<
  Params,
  [Array<Discipline>, SummaryMarks],
  void
> = [
  'cabinet/dnevnik/summary',
  'get',
  ['data', 'marks'],
];
